import { render, staticRenderFns } from "./DuplicateDataRulesWidget.vue?vue&type=template&id=5f32a0db&scoped=true"
import script from "./DuplicateDataRulesWidget.vue?vue&type=script&lang=js"
export * from "./DuplicateDataRulesWidget.vue?vue&type=script&lang=js"
import style0 from "./DuplicateDataRulesWidget.vue?vue&type=style&index=0&id=5f32a0db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f32a0db",
  null
  
)

export default component.exports